import { render, staticRenderFns } from "./SingleDetail.vue?vue&type=template&id=2f902268&"
import script from "./SingleDetail.vue?vue&type=script&lang=js&"
export * from "./SingleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports